import { InjectionToken } from '@angular/core';
import type { AuthBootstrapConfig } from '../interfaces/auth-core.interfaces';

/**
 * Injection token for the resolved AuthBootstrapConfig. Provided by the shell alongside MSAL_INSTANCE so lifecycle and
 * broker services can compose MSAL requests without requiring an extra function parameter.
 */
export const AUTH_BOOTSTRAP_CONFIG = new InjectionToken<AuthBootstrapConfig>('AUTH_BOOTSTRAP_CONFIG');
